import { BaseModel } from './base-model';
import { Account } from './account';
import { Project } from './project';
import { Organization } from './organization';

export class Report extends BaseModel {
  // for CASL subject detection on code minification
  static get modelName() {
    return 'Report';
  }

  /* tslint:disable */
  name: string;
  template: string;
  report_type: string;

  project: Project;
  project_id: string;
  organization: Organization;
  organization_id: string;

  selected: boolean;
  /* tslint:enable */

  get relations() {
    return {
      createdBy: Account,
      updatedBy: Account,
      project: Project,
    };
  }

  /**
   * Processes json obj and sets respective properties.
   * @param jsonObj json from api
   */
  parseJSONData(jsonObj: any) {
    super.parseJSONData(jsonObj);

    this.project_id = this.project?.id || this.project_id;
    this.organization_id = this.organization?.id || this.organization_id;
  }
}
